import React, { useContext } from 'react'
import { ChatbotStepActionData, sendMediaActionData } from '../../../../models/flowBuilderTypes';
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import { Grid, Typography } from '@mui/material';
import formStyles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import globalStyles from "../../../../assets/styles/global.module.scss";
import { checkIfMediaIsSavedInBE, getMediaFileDescription } from '../flowBuilderConstants';
import { getMediaUrl } from '../../../../pages/ruleBasedInbox/utils';
interface SendMediaNodeProps {
    id: string,
    data: ChatbotStepActionData<sendMediaActionData>
} 

const SendMediaNode: React.FC<SendMediaNodeProps> = (props) => {
    
    const { id, data } = props;
    const { action_data } = data;

    const { vendorData } = useContext(UserContext) as UserContextPayload;

    const getMediaFileTitleAndDescription = () => {
        const obj = getMediaFileDescription(data?.flag_saved_in_BE, action_data, "node");
        return {
            title: obj?.title,
            description: obj?.description
        }
    }

    return (
        <>
            <Grid item>
                <Grid container className={`${globalStyles.displayFlexStyle} ${globalStyles.flexColumn}`}>
                    <Grid item>
                        <Typography className={formStyles.dataSavedTextStyle}>
                            {getMediaFileTitleAndDescription()?.title}
                        </Typography>
                    </Grid>

                     <Grid item>
                        {checkIfMediaIsSavedInBE(data?.flag_saved_in_BE, data?.action_data) ? 
                            <a href={getMediaUrl(vendorData, action_data?.google_storage_id)} target='blank' className={`${formStyles.contactListAnchorTag} ${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight}`}>
                                {getMediaFileTitleAndDescription()?.description}
                            </a>
                            :
                            <Typography className={formStyles.dataSavedValueStyle}>
                                {getMediaFileTitleAndDescription()?.description}
                            </Typography>
                        }
                    </Grid>

                </Grid>
            </Grid>
        </>
    )
}

export default SendMediaNode
